import React  from 'react'
import { useEffect } from 'react'
import { Link, Routes , Route  } from 'react-router-dom'
import AddTask from './AddTask'
import AddTaskButton from './AddTaskButton'
import UserName from './UserName'

function Personal(targets) {
  // console.log(window.localStorage.getItem("Name"))
  const name = window.localStorage.getItem("Name")
  const naming = name === null ? window.localStorage.setItem("Name" ,"Default-Page") : window.localStorage.setItem("Name" , name)
  const style = window.localStorage.getItem("Name") === "Default-Page" ? "none" : "block" 

  return (
    <React.Fragment>
      <div className="personal" style={{display : style}}>
        <div className="container">
          <div className="content">
            <div className="left">
              <div className="top">
                <h2>Welcome <span> {name[0].toUpperCase() + name.slice(1)}</span></h2>
                <h6>: تذكر دائما أنه قال</h6>
                <h3>ولسوف يعطيك ربك فترضي</h3>
              </div>
              <div className="bottom">
                <Link to='/finished' className="cont">
                  <h4>Compeleted Tasks</h4>
                  <span>{targets.targets.filter(f => f.finished === true).length}</span>
                </Link >
                <Link to='/deleted' className="cont">
                  <h4>Cancelled Tasks</h4>
                  <span>{targets.targets.filter(f => f.deleted === true).length}</span>
                </Link >
                <Link to='/delayed' className="cont">
                  <h4>Delayed Tasks</h4>
                  <span>{targets.targets.filter(f => f.delayed === true).length}</span>
                </Link >
                <Link to='/progress' className="cont">
                  <h4>Tasks in progress</h4>
                  <span>{targets.targets.filter(f => f.inProgress === true).length}</span>
                </Link >
              </div>
            </div>
            <div className="rightP">
              <Routes>
                <Route path='/' element={<AddTaskButton />} />
                <Route path = 'addtask/' element={<AddTask name ={name} />} />
              </Routes>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default Personal